export const ROLE_PERMISSIONS = {
  'Administrator': {
    tabs: {
      'inventory-status': true,
      'shops': true,
      'items': true,
      'users': true,
      'vendors': true,
      'requests': true,
      'inventory-report': true,
      'pos': false,
      'bills': true,
      'invoices': true,
      'raw-material': true,
      'card-discounts': true
    },
    actions: {
      'add-inventory': false,
      'add-shop': true,
      'add-item': true,
      'edit-item': true,
      'add-user': true,
      'edit-user': true,
      'add-vendor': true,
      'edit-vendor': true,
      'add-request': false,
      'view-request-details': true,
      'dispatch-request': false,
      'delete-request': true,
      'generate-bill': true,
      'delete-bill': true,
      'mark-inventory-lost': true,
      'return-inventory': true,
      'add-raw-item': true,
      'add-raw-item-inventory': true,
      'edit-raw-item': true,
      'edit-raw-item-inventory': true,
      'delete-raw-item-inventory': true,
      'view-raw-material-table': true,
      'view-vendor-inventory-report': true,
      'export-raw-material-pdf': true
    }
  },
  'Factory Inventory Adder': {
    tabs: {
      'inventory-status': true,
      'requests': false,
      'pos': false,
      'bills': false,
      'invoices': false
    },
    actions: {
      'add-inventory': true,
      'add-request': false,
      'view-request-details': false,
      'dispatch-request': false,
      'delete-request': false,
      'generate-bill': false,
      'view-raw-material-table': false,
      'view-vendor-inventory-report': false,
      'export-raw-material-pdf': false
    }
  },
  'Shop POS Operator and Daily Demand Sender': {
    tabs: {
      'inventory-status': true,
      'requests': true,
      'pos': true,
      'bills': true,
      'invoices': true
    },
    actions: {
      'add-inventory': false,
      'add-request': true,
      'view-request-details': true,
      'dispatch-request': false,
      'delete-request': true,
      'generate-bill': true,
      'mark-inventory-lost': true,
      'return-inventory': true,
      'view-raw-material-table': false,
      'view-vendor-inventory-report': false,
      'export-raw-material-pdf': false
    }
  },
  'Factory POS Operator': {
    tabs: {
      'inventory-status': true,
      'requests': false,
      'pos': true,
      'bills': true,
      'invoices': true
    },
    actions: {
      'add-inventory': false,
      'add-request': false,
      'view-request-details': false,
      'dispatch-request': false,
      'delete-request': false,
      'generate-bill': true,
      'view-raw-material-table': false,
      'view-vendor-inventory-report': false,
      'export-raw-material-pdf': false
    }
  },
  'Factory Inventory Dispatcher': {
    tabs: {
      'inventory-status': true,
      'requests': true,
      'pos': false,
      'bills': false,
      'invoices': false
    },
    actions: {
      'add-inventory': false,
      'add-request': false,
      'view-request-details': true,
      'dispatch-request': true,
      'delete-request': false,
      'generate-bill': false,
      'view-raw-material-table': false,
      'view-vendor-inventory-report': false,
      'export-raw-material-pdf': false
    }
  },
  'Director': {
    tabs: {
      'inventory-status': true,
      'shops': true,
      'items': true,
      'users': true,
      'vendors': true,
      'requests': true,
      'inventory-report': true,
      'pos': false,
      'bills': true,
      'invoices': true,
      'raw-material': true,
      'card-discounts': false
    },
    actions: {
      'add-inventory': false,
      'add-shop': false,
      'add-item': false,
      'add-user': false,
      'add-vendor': false,
      'add-request': false,
      'view-request-details': true,
      'dispatch-request': false,
      'delete-request': false,
      'generate-bill': false,
      'view-raw-material-table': true,
      'view-vendor-inventory-report': true,
      'export-raw-material-pdf': true
    }
  },
  'Factory Raw Inventory Adder': {
    tabs: {
      'inventory-status': false,
      'shops': false,
      'items': false,
      'users': false,
      'vendors': false,
      'requests': false,
      'inventory-report': false,
      'pos': false,
      'bills': false,
      'invoices': false,
      'raw-material': true
    },
    actions: {
      'add-inventory': false,
      'add-shop': false,
      'add-item': false,
      'edit-item': false,
      'add-user': false,
      'edit-user': false,
      'add-vendor': false,
      'edit-vendor': false,
      'add-request': false,
      'view-request-details': false,
      'dispatch-request': false,
      'delete-request': false,
      'generate-bill': false,
      'delete-bill': false,
      'mark-inventory-lost': false,
      'return-inventory': false,
      'add-raw-item': false,
      'add-raw-item-inventory': true,
      'edit-raw-item': false,
      'view-raw-material-table': false,
      'view-vendor-inventory-report': false,
      'export-raw-material-pdf': false
    }
  },
  'Bag-Box Printer View': {
    tabs: {
      'inventory-status': false,
      'shops': false,
      'items': false,
      'users': false,
      'vendors': false,
      'requests': false,
      'inventory-report': false,
      'pos': false,
      'bills': false,
      'invoices': false,
      'raw-material': false,
      'data-view': true
    },
    actions: {}
  }
}; 